export default [{
  path: '/stage/quickCashier',
  name: 'stage-quickCashier',
  title: '快捷收银',
  component: () => import('@/views/stage/template/quickCashier/index')
}];
